/****************************************************
 * Module Name:  nivodautilityProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class NivodaUtilityProxy {

    static GetAllCriteria = (callback) => {
        restAPICall(
            Constants.UTILITY_URL + "/nivoda/criteria",
            "get",
            undefined,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static AddCriteria = (criteria, callback) => {
        restAPICall(
            Constants.UTILITY_URL + "/nivoda/criteria",
            "post",
            undefined,
            undefined,
            JSON.stringify(criteria),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static UpdateCriteria = (criteria, callback) => {
        restAPICall(
            Constants.UTILITY_URL + "/nivoda/criteria",
            "put",
            undefined,
            undefined,
            JSON.stringify(criteria),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static CreateAllCriteria = (criteriaList, callback) => {
        restAPICall(
            Constants.UTILITY_URL + "/nivoda/criteria/multiple",
            "post",
            undefined,
            undefined,
            JSON.stringify(criteriaList),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static RefetchCriteria = (criteriaList, callback) => {
        restAPICall(
            Constants.UTILITY_URL + "/nivoda/stonecriteria/refetch",
            "put",
            undefined,
            undefined,
            JSON.stringify(criteriaList),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetPricingData = (stonePricingList, dateParam, callback) => {
        const data = {
            stonePricingList: stonePricingList,
            date: dateParam
        };
        restAPICall(
            Constants.UTILITY_URL + `/nivoda/pricingdata`,
            "post",
            undefined,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetPricingDataByIds = (stonePricingList, dateParam, stonetype, callback) => {
        const data = {
            stonePricingList: stonePricingList,
            date: dateParam,
            stonetype: stonetype
        };
        restAPICall(
            Constants.UTILITY_URL + "/nivoda/pricingdata/ids",
            "post",
            undefined,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetCriteriaStats = (callback) => {
        restAPICall(
            Constants.UTILITY_URL + "/nivoda/criteria/stats",
            "get",
            undefined,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

}